import React, { useState } from 'react';
import { AppBar, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { MobileMenuDrawer } from './MobileMenuDrawer';
import { DesktopMenuDrawer } from './DesktopMenuDrawer';

import { CustomTheme } from '../../../../types/customTheme/customTheme';
import { UsuarioEstaLogado, UsuarioLogadoGet, UsuarioLogout } from '../../../../utils/usuarioEstaLogado';
import { Link } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import configSiteUrls from '../../configs/configSiteUrls';
import configUrls from '../../../../config/configUrls';

import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { HeaderUserMenu } from '../../../../components/header/HeaderUserMenu';

export const HeaderSiteMenu: React.FC = () => {
  const theme = useTheme() as CustomTheme;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const headerMenu = theme.custom?.headerSiteMenu || {};
  const nome = theme.custom?.nome || 'Nome Padrão';

  const backgroundColorMobile = headerMenu.backgroundColorMobile || '#000000';
  const textColorMobile = headerMenu.textColorMobile || '#ffffff';
  const textColorDesktop = headerMenu.textColorDesktop || '#000000';

  const headerTitleStyle = theme.typography?.headerTitle || {
    fontSize: '0.875rem',
    fontWeight: 700
  };


  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: isMobile ? backgroundColorMobile : 'transparent',
        //backgroundColor:"primary",
        color: isMobile ? textColorMobile : textColorDesktop
      }}
      id="header-site-menu"
    >
      <Toolbar sx={{ justifyContent: 'space-between', px: 2 }}>
        {isMobile ? (
          <>
            <MobileMenuDrawer layout="site" />
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: headerTitleStyle.fontSize,
                fontWeight: headerTitleStyle.fontWeight,
                color: textColorMobile,
                textAlign: 'center'
              }}
            >
              {nome}
            </Typography>
          </>
        ) : (
          <Box sx={{ flexGrow: 1 }}>
            <DesktopMenuDrawer layout="site" />
          </Box>
        )}
        <>
          <HeaderUserMenu sistema="site" />
        </>
      </Toolbar>
    </AppBar>
  );
};
